import { render, staticRenderFns } from "./sendingSettings.vue?vue&type=template&id=6c66ecf1&scoped=true&"
import script from "./sendingSettings.vue?vue&type=script&lang=js&"
export * from "./sendingSettings.vue?vue&type=script&lang=js&"
import style0 from "./sendingSettings.vue?vue&type=style&index=0&lang=css&"
import style1 from "./sendingSettings.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./sendingSettings.vue?vue&type=style&index=2&id=6c66ecf1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c66ecf1",
  null
  
)

export default component.exports